/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components/macro';
import React, { useState, useRef, useEffect } from 'react';
import { ArrowUpIcon, CheckIcon } from 'assets/icons';
import { IOption } from 'shared/interfaces/IOption';

export type ISelectionOption = IOption;
interface ISelectionProps {
  list: ISelectionOption[];
  selectedItem: ISelectionOption;
  onSelectItem: (item: ISelectionOption) => void;
  rightPosition?: string;
}

const Selection = ({ selectedItem, list, onSelectItem, rightPosition }: ISelectionProps): JSX.Element => {
  const node = useRef<HTMLDivElement | null>(null);
  const [opened, setOpened] = useState(false);

  const handleSelectItem = (item: ISelectionOption) => (): void => {
    onSelectItem(item);
    setOpened(false);
  };

  const handleToggleDropDown = (e: React.MouseEvent | MouseEvent): void => {
    if (node?.current?.contains(e.target as Node)) {
      setOpened(true);
      return;
    }
    setOpened(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleToggleDropDown);
    return (): void => document.removeEventListener('mousedown', handleToggleDropDown);
  }, []);

  return (
    <Container>
      <Select ref={node}>
        <ActionsHeader>
          {list.length > 1 ? (
            <Trigger onClick={handleToggleDropDown}>
              <SelectedItem>
                {selectedItem.label.substring(0, 8) + (selectedItem.label.length > 10 ? '...' : '')}
              </SelectedItem>
              <ChevronButton />
            </Trigger>
          ) : (
            <SelectedItem>{selectedItem.label}</SelectedItem>
          )}
        </ActionsHeader>
        {opened && list.length > 1 && (
          <DropDown rightPosition={rightPosition}>
            {list.map((item: ISelectionOption): JSX.Element => {
              return (
                <Item key={item.value} onClick={handleSelectItem(item)}>
                  {item.label}
                  {selectedItem.label === item.label && <CheckIcon />}
                </Item>
              );
            })}
          </DropDown>
        )}
        {list.length === 1 && <div onClick={handleSelectItem(selectedItem)} />}
      </Select>
    </Container>
  );
};

interface IDropdownProps {
  rightPosition?: string;
}

const Container = styled.div`
  text-align: center;
  margin-left: 4px;
  &:hover {
    background: #eee;
  }
  cursor: pointer;
`;

const ActionsHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 16px 0 0;
`;

const Select = styled.div`
  position: relative;
`;

const Trigger = styled.div`
  cursor: pointer;
  display: flex;
`;

const ChevronButton = styled(ArrowUpIcon)`
  transform: rotate(180deg);
  max-width: 16px;
  width: 16px;
  margin-top: 4px;
  flex: 1;
`;

const DropDown = styled.div<IDropdownProps>`
  position: absolute;
  top: 100%;
  right: ${({ rightPosition }): string => (rightPosition !== undefined ? rightPosition : '-10px')};
  z-index: 800;
  min-width: 200px;
`;

const Item = styled.div`
  display: flex;
  cursor: pointer;
  text-align: left;
  justify-content: space-between;
  &:hover {
    background: #eee;
  }
`;

const SelectedItem = styled.div`
  display: inline-flex;
  flex: 2;
`;

export default Selection;
